// @flow

import React, {Component} from 'react';
import groupBy from 'lodash.groupby';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import {TreeNode} from './tree-node.component';
import {getCurrPrefix} from './utils';
import styles from './tree.component.module.styl';

import type {Element, ElementProps} from 'react';

import type {TreeStructure, ExpandedTree, ExpandedTreeItem, NodeProps} from './typedef';
import type {PrefixType} from './constants';


const classes = hashedClasses(styles);

type Props = {|
    ...$Exact<ElementProps<'div'>>,
    expandedIdsTree: ExpandedTree,
    updateExpandedIds: (expandedIdsTree: ExpandedTree) => void,
    data: TreeStructure,
    getNode: (props: NodeProps) => Element<any>,
    disabled: boolean,
    prefixType: PrefixType,
    isFlat?: boolean,
    prefix: string,
|};

export class TreeContainer extends Component<Props> {
    static defaultProps = {
        prefix: ''
    };

    updateExpandedIds = (currentExpandedState: ExpandedTreeItem, id: string) => {
        this.props.updateExpandedIds({
            ...this.props.expandedIdsTree,
            [id]: currentExpandedState
        });
    };

    renderTree = (data: TreeStructure, index?: number) => {
        const {
            getNode,
            expandedIdsTree,
            updateExpandedIds,
            disabled,
            isFlat,
            prefix,
            prefixType,
            'aria-level': ariaLevel = 1,
        } = this.props;

        return data.length > 0 ? (
            <div className={classes.tree__list} key={index} role="group">
                {data.map((nodeData, i) => (
                    <TreeNode
                        key={nodeData.id}
                        aria-level={ariaLevel}
                        {...{
                            expandedIdsTree: expandedIdsTree[nodeData.id] || {},
                            updateExpandedIds,
                            updateExpandedIdsTree: this.updateExpandedIds,
                            data: nodeData,
                            getNode,
                            disabled,
                            isFlat,
                            prefixType,
                            prefix: getCurrPrefix({
                                prefix,
                                prefixType,
                                index: i,
                                id: nodeData.id
                            })
                        }}
                    />
                ))}
            </div>
        ) : null;
    };

    render() {
        const {data} = this.props;

        if (data.length > 0 && data.every(i => i.column)) {
            const groupedColumns = groupBy(data, 'column');

            return (
                <div className={classes.tree__lists}>
                    {Object.keys(groupedColumns)
                        .filter(filteredItem => groupedColumns[filteredItem].some(treeItem => {
                            // Item checked for undefined for default Tree behavior, and treeItem.matchedSearch for search in drop down tree
                            if(treeItem.matchedSearch === undefined || treeItem.matchedSearch) {
                                return treeItem;
                            }
                        }))
                        .map((item, index) => (
                            <div key={item} className={classes['tree__list-wrapper']}>
                                {this.renderTree(groupedColumns[item], index)}
                            </div>
                        ))}
                </div>
            );
        }

        return this.renderTree(data);
    }
}
